var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeletePlan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.545,
    height: 16.22,
    viewBox: "0 0 9.545 16.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_delete",
    transform: "translate(-0.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.818,0A.682.682,0,0,1,7.5.682H8.863a.682.682,0,0,1,0,1.364H.682a.682.682,0,1,1,0-1.364H2.045A.682.682,0,0,1,2.727,0Z",
    transform: "translate(0.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.5,13h-6A1.71,1.71,0,0,1,0,11.142V0H9V11.142A1.71,1.71,0,0,1,7.5,13ZM6.375,1.857A.427.427,0,0,0,6,2.322v8.357a.427.427,0,0,0,.375.464.427.427,0,0,0,.375-.464V2.322A.428.428,0,0,0,6.375,1.857Zm-3.75,0a.428.428,0,0,0-.375.465v8.357a.427.427,0,0,0,.375.464A.427.427,0,0,0,3,10.678V2.322A.427.427,0,0,0,2.625,1.857Z",
    transform: "translate(0.597 3.22)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeletePlan);
export default __webpack_public_path__ + "static/media/Icon_delete_plan.eaa36e0fc481cfa5e9c806bb4ff31a17.svg";
export { ForwardRef as ReactComponent };